import './discovery.scss';
import SnowTheme from 'quill/themes/snow';

class DiscoveryTheme extends SnowTheme {
  extendToolbar(toolbar) {
    super.extendToolbar(toolbar);

    const buttons = toolbar.container.querySelectorAll('button');
    [].forEach.call(buttons, (button) => {
      button.innerHTML = '';
    });
  }
}

export default DiscoveryTheme;
